// Hero floating particles - drop into: assets/p3d-particles.js
(function(){
  function init(){
    var pc = document.getElementById('p3d-parts');
    if(!pc) return;
    for(var i=0; i<26; i++){
      var s = document.createElement('span');
      s.style.left = Math.random()*100 + '%';
      s.style.animationDuration = (8 + Math.random()*14) + 's';
      s.style.animationDelay = (Math.random()*10) + 's';
      pc.appendChild(s);
    }
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Mobile nav drawer toggle
  window.p3dToggleNav = function(open){
    var d = document.getElementById('p3d-nav-drawer');
    var o = document.getElementById('p3d-nav-overlay');
    if(!d || !o) return;
    if(open){ d.classList.add('open'); o.classList.add('open'); }
    else { d.classList.remove('open'); o.classList.remove('open'); }
  };
})();